import Env from '../BsGetEnv';
import BsUtil from '../BsUtil';
// import Didasdk from '../bs-didasdk';

class FPsdk {
  constructor() {
    this.__isinit = false;
  }
  __init() {
    this.__isinit = true;
    window._smReadyFuncs = [];
    window.SMSdk = {
      ready: function(fn) {
        fn && window._smReadyFuncs.push(fn);
      }
    };
    // 1. 通用配置项
    window._smConf = {
      organization: 'ZaY7P36K6ysoA4iZylFr', // 必填，组织标识，邮件中 organization 项
      staticHost: 'static.fengkongcloud.com'// 2.连接海外机房特殊配置项，仅供设备数据上报海外机房客户使用
    };
    let url = (function() {
      let originHost = 'static2.fengkongcloud.com';
      let isHttps = document.location.protocol === 'https:';
      let protocol = isHttps ? 'https://' : 'http://';
      let fpJsPath = '/fpv2.js';
      let url = protocol + window._smConf.staticHost + fpJsPath;
      let ua = navigator.userAgent.toLowerCase();
      let isWinXP = /windows\s(?:nt\s5.1)|(?:xp)/.test(ua);
      let isLowIE = /msie\s[678]\.0/.test(ua);
      if (isHttps && isWinXP && isLowIE) {
        url = protocol + originHost + fpJsPath;
      }
      return url;
    })();
    let sm = document.createElement('script');
    let s = document.getElementsByTagName('script')[0];
    sm.src = url;
    s.parentNode.insertBefore(sm, s);
  }

  /**
   * cb 业务逻辑
   * 使用数美设备标识逻辑
   */
  dealSmDeviceId(cb) {
    try {
      if (!this.__isinit) {
        this.__init();
      }
      let smDeviceId = '';
      window.SMSdk.ready(function() {
        smDeviceId = window.SMSdk.getDeviceId ? window.SMSdk.getDeviceId() : smDeviceId;
        cb && cb(smDeviceId);
      });
    } catch (e) {
      cb && cb('');
      console.log('获取deviceId失败');
    }
  }
}

let $deviceId = '';
const fpsdk = new FPsdk();

export default fpsdk;

export function getSMDeviceId() {
  return new Promise(resolve => {
    if ($deviceId) {
      resolve($deviceId);
      return;
    }
    try {
      if (Env.inApplication && BsUtil.compareVersion(Env.curAppVersion, '8.10.0') >= 0 && window.DIDASDK) {

        // Didasdk.ready(function() {
          // 获取App数美id
          window.DIDASDK.invoke('getSMDeviceId', {}, res => {
            try {
              // console.info('[util.fp] [getSMDeviceId] getSMDeviceId res => ' + `(${res})`);
              $deviceId = JSON.parse(res).device_id;
            } catch (e) {
              console.error('[util.fp] [getSMDeviceId] getSMDeviceId 1 => \n', e);
            }
            if ($deviceId) {
              resolve($deviceId);
            } else {
              fpsdk.dealSmDeviceId(function(deviceId) {
                if (deviceId) {
                  $deviceId = deviceId;
                } else {
                  console.info('[util.fp] [getSMDeviceId] dealSmDeviceId 没有deviceId 1');
                }
                resolve($deviceId);
              });
            }
          });
        // });
      } else {
        fpsdk.dealSmDeviceId(function(deviceId) {
          if (deviceId) {
            $deviceId = deviceId;
          } else {
            console.info('[util.fp] [getSMDeviceId] dealSmDeviceId 没有deviceId 2');
          }
          resolve($deviceId);
        });
      }
    } catch (e) {
      console.error('[util.fp] [getSMDeviceId] 2 => \n', e);
      resolve($deviceId);
    }
  });
}
